import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, Row, Col, Statistic, message } from 'antd';
import { UserOutlined, TeamOutlined, RiseOutlined } from '@ant-design/icons';
import api from '../services/api';

interface UserItem {
  username: string;
  phone: string;
  email: string;
  role: string;
  company_size: string;
  practice_area: string;
  created_at: string;
}

const AdminUsersPage: React.FC = () => {
  const [users, setUsers] = useState<UserItem[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [usersRes, statsRes] = await Promise.all([
        api.get('/admin/users'),
        api.get('/admin/stats'),
      ]);
      setUsers(usersRes.data.users);
      setStats(statsRes.data);
    } catch (error: any) {
      message.error(error.response?.data?.detail || '获取数据失败');
    } finally {
      setLoading(false);
    }
  };

  const roleMap: Record<string, string> = {
    lawyer: '律师',
    legal: '法务',
    owner: '企业主',
    other: '其他',
  };

  const columns = [
    { title: '用户名', dataIndex: 'username', key: 'username' },
    { title: '邮箱', dataIndex: 'email', key: 'email' },
    { title: '手机号', dataIndex: 'phone', key: 'phone' },
    {
      title: '身份',
      dataIndex: 'role',
      key: 'role',
      render: (role: string) => role ? <Tag color="blue">{roleMap[role] || role}</Tag> : '-',
    },
    { title: '公司规模', dataIndex: 'company_size', key: 'company_size', render: (v: string) => v || '-' },
    { title: '业务领域', dataIndex: 'practice_area', key: 'practice_area', render: (v: string) => v || '-' },
    {
      title: '注册时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (t: string) => t ? new Date(t).toLocaleString() : '-',
    },
  ];

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>用户管理</h1>

      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card>
            <Statistic title="总用户数" value={stats?.total || 0} prefix={<TeamOutlined />} />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic title="今日新增" value={stats?.today_new || 0} prefix={<RiseOutlined />} />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic title="身份分布" value={stats?.role_distribution?.length || 0} suffix="种" prefix={<UserOutlined />} />
          </Card>
        </Col>
      </Row>

      {/* 用户列表 */}
      <Card title="用户列表">
        <Table
          dataSource={users}
          columns={columns}
          rowKey="username"
          loading={loading}
          pagination={{ pageSize: 10 }}
        />
      </Card>
    </div>
  );
};

export default AdminUsersPage;